import Alpine from "@alpinejs/csp";

/**
 * Compare site and browser language
 * open modal with option to switch to english version of the site
 * if the site is german and the users browser is not
 */
export default () => ({
  // showLangModal: false,
  // languageSet: localStorage.getItem('language-selected') ?? false,

  showModal() {
    Alpine.store("global").showLangTopbar = true;
  },

  hideModal() {
    Alpine.store("global").showLangTopbar = false;
    this.setLanguage();
  },

  // save in local storage that user selected a language
  // to prevent modal from showing again after user switched lang or closed modal
  setLanguage() {
    localStorage.setItem("language-selected", true);
    Alpine.store("global").languageSet = true;
  },

  openCtaModal() {
    Alpine.store("global").showCtaModal = true;
  },

  switchLanguage(event) {
    this.setLanguage();
    window.location = event.target.value;
  },

  redirectLanguage() {
    // get english translated url of current page
    const url = document.querySelector(
      '[is="languageSwitcher"] [data-lang="EN"]',
    ).dataset.link;

    // prevent modal from showing again
    this.setLanguage();

    // redirect to english page
    window.location = url;
  },

  init() {
    // abort if user already chose a language
    if (Alpine.store("global").languageSet) return;

    // get browser language
    const browserLanguage = navigator.language.split("-")[0].toUpperCase();

    // show modal to switch language
    // if site language is german and browser language is not german
    if (
      Alpine.store("global").activeSiteLanguage === "DE" &&
      browserLanguage !== "DE"
    ) {
      // show modal
      this.showModal();
    }
  },
});
